import { generateContext } from '@btime/react-contexts'
import React, { useCallback, useEffect } from 'react'

const { ActionsContext, Provider } = generateContext()

export const useHelpActions = () => React.useContext(ActionsContext) || {}

const GLEAP_SDK_KEY = 'nD3wRzWs7uL3mLyDPGcKwZo50zOT7Dwd'

const HelpProvider = ({ children }) => {
  useEffect(() => {
    window.Gleap.initialize(GLEAP_SDK_KEY)
  }, [])

  const initChat = useCallback(({ user_id, name, email, company }) => {
    window.Gleap.identify(user_id, {
      name,
      email,
      companyId: company?.id,
      companyName: company?.name,
      customData: { workspace: company?.id }
    })
  }, [])

  const openChat = useCallback(() => {
    window.Gleap.open()
  }, [])

  const openPrimaryHelpOption = openChat

  return <Provider actions={{ openChat, initChat, openPrimaryHelpOption }}>{children}</Provider>
}

export default HelpProvider
